export const brewingMethods = [
  { id: 'espresso', name: 'Espresso/Portafilter (Siebträger)', icon: '☕' },
  { id: 'v60', name: 'V60 Pour Over', icon: '🔻' },
  { id: 'chemex', name: 'Chemex', icon: '⏳' },
  { id: 'frenchpress', name: 'French Press', icon: '🫖' },
  { id: 'aeropress', name: 'AeroPress', icon: '💉' },
  { id: 'moka', name: 'Moka Pot', icon: '🫗' },
  { id: 'dripper', name: 'Dripper', icon: '☕' },
  { id: 'filter', name: 'Filter Coffee', icon: '📄' },
  { id: 'coldbrew', name: 'Cold Brew', icon: '🧊' }
];
